import { LoadingIndicator } from 'components/LoadingIndicator';
import { useSuspendedUIDelay } from 'hooks/useDelay';

import { Container } from './LoadingSection.styled';

type Props = {
  noDelay?: boolean;
};

export function LoadingSection({ noDelay }: Props) {
  const { pastDelay } = useSuspendedUIDelay();

  if (!noDelay && !pastDelay) return null;

  return (
    <Container>
      <LoadingIndicator />
    </Container>
  );
}
